import { ChangeEvent, useState } from 'react';
import { createEmptyFormState } from '../accountFormTypes';

export default function useHandleFormInput() {
  const [formState, setFormState] = useState(createEmptyFormState());
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const property = event.target.name;
    const updatedFormState = {
      ...formState,
      ...{ [property]: event.target.value },
    };
    setFormState(updatedFormState);
  };

  return {
    formState,
    handleOnChange,
    setFormState,
  };
}
